import { derived, writable } from "svelte/store";
export const backNavigationUrl = writable(null);
export const latestLocation = writable(null);
export const alertShown = writable(false);
export const modalComponent = writable(null);
export const modalData = writable(null);
export const modalCloseAction = writable(null);
export const latestScanResult = writable(null);
export const documentData = writable(null);
export const payslipData = writable(null);
class CentralStorage {
    constructor(pageTitle = writable(null)) {
        this.pageTitle = pageTitle;
    }
    get compiledTitle() {
        return derived(this.pageTitle, ($pageTitle) => {
            return $pageTitle ? `${$pageTitle} - HAND for Workers` : 'HAND for Workers';
        });
    }
}
export const coreStore = new CentralStorage();
